// @flow
import React, { useContext, useState } from 'react';
import {
  TABLEFLOW_RESOURCES_GRID_FIELDNAMES,
  TABLEFLOW_RESOURCES_GRID_HEADERS,
} from '@streaming-projects/orgs/enums';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { PrimaryButton } from '@presentational/buttons/PrimaryButton';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import { useMetaDataContext } from '@streaming-projects/orgs/contexts/SPMetaDataContextProvider';
import {
  getMappedDataValueGetter,
  getRegionName,
} from '@streaming-projects/resource-definitions/auxilary-components/MappedDataRenderer';
import { SPTableFlowEditRenderer } from '@streaming-projects/resource-definitions/tableflow-resource-definitions/SPTableFlowEditRenderer';
import { SPTableFlowDeleteRenderer } from '@streaming-projects/resource-definitions/tableflow-resource-definitions/SPTableFlowDeleteRenderer';
import { DataGrid } from '@components/views/grid-utils/DataGrid';
import { SPTableFlowConfigurationAddEditModal } from '@streaming-projects/resource-definitions/tableflow-resource-definitions/SPTableFlowConfigurationAddEditModal';

export const SPTableFlowResourceConfigurationsSummaryContainer = () => {
  const [isTableFlowConfigAddEditModalOpen, setTableFlowConfigAddEditModalOpen] = useState(false);

  const { providerRegionsMap, providerNameLabelMap, tableFlowStorageTypeMap } =
    useMetaDataContext();

  const inputDataSource = useContext(SPOrgContext)?.resources?.tableflow_resources ?? [];
  const areAnyTableFlowResourcesConfigured = inputDataSource?.length > 0;

  const columnDefs = [
    {
      field: TABLEFLOW_RESOURCES_GRID_HEADERS.ID,
      backEndFieldName: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.ID,
      hide: true,
    },
    {
      field: TABLEFLOW_RESOURCES_GRID_HEADERS.NAME,
      backEndFieldName: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.NAME,
    },
    {
      field: TABLEFLOW_RESOURCES_GRID_HEADERS.STORAGE_TYPE,
      backEndFieldName: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.STORAGE_TYPE,
      valueGetter: getMappedDataValueGetter(tableFlowStorageTypeMap),
    },
    {
      field: TABLEFLOW_RESOURCES_GRID_HEADERS.CLUSTER_RESOURCE_NAME,
      backEndFieldName: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_NAME,
    },
    {
      field: TABLEFLOW_RESOURCES_GRID_HEADERS.CLUSTER_RESOURCE_PROVIDER,
      backEndFieldName: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_PROVIDER,
      valueGetter: getMappedDataValueGetter(providerNameLabelMap),
    },
    {
      field: TABLEFLOW_RESOURCES_GRID_HEADERS.CLUSTER_RESOURCE_REGION,
      backEndFieldName: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_REGION,
      tooltipValueGetter: (params) => getRegionName(params, providerRegionsMap),
      valueGetter: (params) => getRegionName(params, providerRegionsMap),
    },
    {
      field: TABLEFLOW_RESOURCES_GRID_HEADERS.CLUSTER_RESOURCE_ID,
      backEndFieldName: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_ID,
      hide: true,
    },
    {
      field: TABLEFLOW_RESOURCES_GRID_HEADERS.VERSION,
      backEndFieldName: TABLEFLOW_RESOURCES_GRID_FIELDNAMES.VERSION,
      hide: true,
    },
    {
      field: '',
      filter: false,
      cellRenderer: SPTableFlowEditRenderer,
      suppressSizeToFit: true,
      maxWidth: 60,
      sortable: false,
    },
    {
      field: '',
      filter: false,
      cellRenderer: SPTableFlowDeleteRenderer,
      suppressSizeToFit: true,
      maxWidth: 60,
      sortable: false,
    },
  ];

  return (
    <PaddedAndRaisedSegment>
      <PrimaryButton
        onClick={() => {
          setTableFlowConfigAddEditModalOpen(true);
        }}
        size="mini"
        text="Add TableFlow Shared Resource Configuration"
      />

      <SPTableFlowConfigurationAddEditModal
        isOpen={isTableFlowConfigAddEditModalOpen}
        setOpen={setTableFlowConfigAddEditModalOpen}
      />

      {areAnyTableFlowResourcesConfigured && (
        <DataGrid
          columnDefs={columnDefs}
          displayResizingColsOption={true}
          downloadAllCols={false}
          inputDataSource={inputDataSource}
          label="TableFlow Configuration Summary"
          sizeColumnsToFitInitially={true}
          tooltipShowDelay={0}
        />
      )}
    </PaddedAndRaisedSegment>
  );
};
